import { useWorkflow } from '../workflow/hooks';
import { useResolutions } from './useResolutions';
import { getExchange } from '../components/tasks/helpers';
import { getItemDescription } from '../utils/item';
import type { OrderItem } from '../graphql/query/getOrder';

export const useExchangeInfo = ({ item }: { item: OrderItem }) => {
  const { data } = useWorkflow();

  if (!data?.items) {
    throw new Error('Cannot resolve without item data');
  }
  const resolutionsByItem = useResolutions();

  const exchangeProps = getExchange(resolutionsByItem?.[item.id]);

  const selectedVariant = exchangeProps?.exchangeVariant;
  const sameProduct = exchangeProps?.sameProduct;

  const selectedVariantDescription =
    selectedVariant &&
    'variantId' in selectedVariant &&
    getItemDescription({
      item: {
        variant: {
          id: selectedVariant.variantId ?? '',
          info: [
            ...(selectedVariant.price?.formattedString
              ? [
                  {
                    name: 'price',
                    value: selectedVariant.price.formattedString,
                  },
                ]
              : []),
            ...selectedVariant.attributes.map(
              (attr: { name: string; value: string }) => ({
                name: attr.name.toLowerCase(),
                value: attr.value,
              }),
            ),
          ],
        },
      },
    });

  return {
    selectedVariantDescription,
    sameProduct,
    selectedVariant,
  };
};
